import { ON_SHOW_VISITS_LOADER, ON_HIDE_VISITS_LOADER, HIDE_MESSAGE } from '../../../constants/ActionTypes';



export const showVisitsLoader = () => {
    return {
        type: ON_SHOW_VISITS_LOADER,
    };
};

export const hideMessage = () => {
    return {
        type: HIDE_MESSAGE,
    };
};